import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
//import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import registerServiceWorker from './registerServiceWorker';
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { PublicClientApplication } from '@azure/msal-browser';
import { App } from './App';
import { BrowserRouter } from 'react-router-dom';

const msalInstance = new PublicClientApplication(msalConfig);

// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory(/*{ basename: baseUrl }*/);

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

ReactDOM.render(
    <Provider store={store}>
        <MsalProvider instance={msalInstance}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </MsalProvider>

    </Provider>,
    document.getElementById('root'));
//ReactDOM.render(
//    <Provider store={store}>
//        <MsalProvider instance={msalInstance}>
//            <ConnectedRouter history={history}>
//                <App />
//            </ConnectedRouter>
//        </MsalProvider>

//    </Provider>,
//    document.getElementById('root'));

registerServiceWorker();
